import gql from 'graphql-tag';
import organizationFragment from 'ApolloClient/Fragments/organizationFragment';

import {
  REMIND_CLIENT_OF_UPCOMING_INVOICE,
  REMIND_CLIENT_OF_SESSION,
  REMIND_CLIENT_OF_LATE_INVOICE,
} from 'lib/constants/cron-job-types';

const GET_PAYPAL_AUTH_TOKEN_FROM_CODE = gql`
  mutation getPaypalAuthTokenFromCode($code: String!) {
    getPaypalAuthTokenFromCode(code: $code) {
      _id
      emails {
        address
        verified
      }

      roles
      profile {
        firstName
        lastName
        image
        subscribed
        description
        organizationId
      }
      organization {
        ...organizationFragment
        nedNotificationsSettings {
          ${REMIND_CLIENT_OF_SESSION} {
              sms
              email
              days
            }
            ${REMIND_CLIENT_OF_UPCOMING_INVOICE} {
              sms
              email
              days
            }
            ${REMIND_CLIENT_OF_LATE_INVOICE} {
              sms
              email
              days
            }
        }
      }
      timezone
      googleCalendarSet
      paypalSet
      paypalEmail
      stripeSet
      paymentOptions
      twilio {
        phone
      }
      notificationsSettings {
        invoicePaid {
          email
          sms
          push
        }
        contractSigned  {
          email
          sms
          push
        }
        newLead  {
          email
          sms
          push
        }
      }
    }
  }
  ${organizationFragment}
`;

export default GET_PAYPAL_AUTH_TOKEN_FROM_CODE;



// WEBPACK FOOTER //
// ./src/ApolloClient/Mutations/getPaypalAuthTokenFromCode.js